import gql from 'graphql-tag';

export const GET_PLAN_NAME = gql`
  query getPlanName($id: Int!) {
    plan(id: $id) {
      id
      name
    }
  }
`;

export const getPlanNameMock = {
  plan: { id: 20, name: 'My nickname' },
};
